import React from "react";
import Report from "../control/report";

const ReportToParent : React.FC<any> = () => {

    return (
        <div>
            <Report />
        </div>
    );
}

export default ReportToParent;